import { render, staticRenderFns } from "./BlankTile.vue?vue&type=template&id=72dc9999&scoped=true&functional=true"
import script from "./BlankTile.vue?vue&type=script&lang=ts"
export * from "./BlankTile.vue?vue&type=script&lang=ts"
import style0 from "./BlankTile.vue?vue&type=style&index=0&id=72dc9999&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "72dc9999",
  null
  
)

export default component.exports